const pick = (lines) => lines[Math.floor(Math.random() * lines.length)];

const JUMP_START_RANK = {
  animal: 'Snail',
  messages: [
    "Jump start! 🐌 The lights were still on. That’s a five-second penalty and a lifetime of shame.",
    "Jump start! 🐌 You launched before the gantry said go. Even a formation lap waits for lights out.",
    "Jump start! 🐌 False start. The FIA would have you in the stewards’ office before you left the box.",
  ],
};

const TIME_RANKS = [
  {
    minMs: 280,
    animal: 'Snail',
    messages: [
      "Snail rank! 🐌 {ms} ms. Did you wait for a radio call? The pack is already at turn one.",
      "Snail rank! 🐌 {ms} ms. That’s not a reaction. That’s a polite RSVP to lights that already left.",
    ],
  },
  {
    minMs: 220,
    animal: 'Turtle',
    messages: [
      "Turtle mode! 🐢 {ms} ms. Slow, muddy, and proud of it. You saw the lights go out and filed a complaint.",
      "Turtle mode! 🐢 {ms} ms. Grandmas in the grandstand reacted faster. The grid did not wait.",
    ],
  },
  {
    minMs: 180,
    animal: 'Rabbit',
    messages: [
      "Rabbit rank! 🐇 {ms} ms. Mid at best. Don’t get hoppy — human-typical isn’t a trophy.",
      "Rabbit rank! 🐇 {ms} ms. Average reflexes with extra confidence. The gantry is unimpressed.",
    ],
  },
  {
    minMs: 150,
    animal: 'Wolf',
    messages: [
      "Wolf rank? 🐺 {ms} ms. Barely. A little under 200 isn’t a personality. The pack would scroll past this.",
      "Wolf rank? 🐺 {ms} ms. Typical human. Typical isn’t praise. Come back when you’re actually fast.",
    ],
  },
  {
    minMs: 120,
    animal: 'Cheetah',
    messages: [
      "Cheetah? 🐆 Don’t. {ms} ms is fine for a human. Fine isn’t elite. Come back under 120.",
      "Cheetah? 🐆 {ms} ms. Sub-150 isn’t a personality. You almost earned a compliment. Almost.",
    ],
  },
  {
    minMs: 100,
    animal: 'Falcon',
    messages: [
      "Falcon-level launch! 🦅 {ms} ms. That’s actually impressive. Lights out, and you were gone.",
      "Falcon-level reaction! 🦅 {ms} ms. Rare praise: you earned it. One more nudge under 100?",
    ],
  },
  {
    minMs: 0,
    animal: 'Peregrine Falcon',
    messages: [
      "Peregrine Falcon! 🦅 {ms} ms. Are you even human? That gantry didn’t stand a chance.",
      "Peregrine Falcon! 🦅 {ms} ms. Lights-out energy. The rest of the grid is still watching red.",
    ],
  },
];

const fillMs = (message, ms) => message.replace(/\{ms\}/g, String(ms));

export const getJumpStartRank = () => ({
  animal: JUMP_START_RANK.animal,
  message: pick(JUMP_START_RANK.messages),
});

export const getReactionRank = (ms) => {
  const value = Number(ms);
  const time = Number.isFinite(value) ? value : 9999;
  const band = TIME_RANKS.find((entry) => time >= entry.minMs) || TIME_RANKS[TIME_RANKS.length - 1];
  return {
    animal: band.animal,
    message: fillMs(pick(band.messages), Math.round(time)),
  };
};

export const LIGHT_COUNT = 5;
export const LIGHT_INTERVAL_MS = 1000;
export const DELAY_MIN_MS = 200;
export const DELAY_MAX_MS = 3000;

export const randomLightsOutDelay = () =>
  DELAY_MIN_MS + Math.random() * (DELAY_MAX_MS - DELAY_MIN_MS);
